// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2rJjO","legacyBtn":"MutateMid_legacyBtn__1oPIZ"};